import React from 'react';
export function Section1Origin() {
  return <section className="w-full bg-white py-16 px-4 border-b border-gray-200" data-id="element-60">
      <div className="max-w-3xl mx-auto space-y-8" data-id="element-61">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 border-b-2 border-gold-500 pb-4 inline-block" data-id="element-62">
          CÓMO EMPEZÓ ESTA INVESTIGACIÓN
        </h2>

        <div className="space-y-6 text-lg text-gray-800 font-serif leading-relaxed" data-id="element-63">
          <p data-id="element-64">Todo comenzó con una llamada.</p>

          <p data-id="element-65">
            Una mujer llamada Sandra, 42 años, madre de dos hijos, nos contactó
            llorando.
          </p>

          <p className="font-bold text-navy-900" data-id="element-66">Había perdido dinero.</p>

          <p data-id="element-67">No en una inversión fallida. No en una estafa de internet.</p>

          <p data-id="element-68">
            Los había perdido con un "espiritista" que le prometió traer de
            vuelta a su esposo en 7 días.
          </p>

          <p data-id="element-69">Pasaron los 7 días. Luego 30. Luego 90.</p>

          <p data-id="element-70">
            El esposo nunca volvió. Pero el espiritista no desapareció de
            inmediato — primero le pidió más dinero. Una y otra vez. Cada semana
            había un nuevo "ritual necesario", un nuevo material, una nueva
            razón para seguir pagando. Cuando Sandra ya no pudo pagar más,
            entonces sí — dejó de contestar.
          </p>

          <p className="italic text-gray-600 border-l-4 border-gray-300 pl-4 my-8" data-id="element-71">
            Sandra no era la primera. Ni sería la última.
          </p>

          <p data-id="element-72">
            Cuando empezamos a investigar, encontramos que su historia se
            repetía con una frecuencia alarmante en comunidades hispanas de toda
            la Florida, Texas, California y Nueva York.
          </p>

          <p data-id="element-73">Fue entonces cuando decidimos ir más lejos.</p>

          <p className="font-bold text-xl text-navy-900 mt-8" data-id="element-74">
            Si había tanto fraude en este mundo — ¿existía algo real?
          </p>
        </div>
      </div>
    </section>;
}